import { spacer16, spacer40, spacer48, } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { MAX_CONTENT_SCREEN_WIDTH, MAX_CONTENT_WIDTH, MD_GRID_MAX_WIDTH, ONE_COLUMN_MAX_WIDTH, TWO_COLUMN_MAX_WIDTH, } from '../../Grid';
const MAX_CONTENT_AFFORDANCE_VIDEO_WIDTH = '148.8px';
const RESPONSIVE_AFFORADANCE_VIDEO_SCREEN_MAX = '1833.6px';
export const Carousel = styled.div `
  --gap: 8px;
  overflow: hidden;
  position: relative;

  // above max content width we want to show affordance video + gap
  // on each side beyond max content width
  width: ${({ isCompact }) => isCompact
    ? 'unset'
    : `calc(
    ${MAX_CONTENT_WIDTH} + ( 2 *
      (${MAX_CONTENT_AFFORDANCE_VIDEO_WIDTH} + var(--gap)))
  )`};

  margin-inline: ${({ isCompact }) => isCompact
    ? 'unset'
    : `calc(-1 * ${MAX_CONTENT_AFFORDANCE_VIDEO_WIDTH} - var(--gap))`};

  // between MAX_CONTENT_SCREEN_WIDTH and RESPONSIVE_AFFORADANCE_VIDEO_SCREEN_MAX
  // the affordance video will scale up responsively until it is at the MAX_CONTENT_AFFORDANCE_VIDEO_WIDTH
  // maintaining full bleed
  @media (max-width: ${RESPONSIVE_AFFORADANCE_VIDEO_SCREEN_MAX}) {
    width: ${({ isCompact }) => (isCompact ? 'unset' : '100vw')};

    margin-inline: ${({ isCompact }) => isCompact ? 'unset' : `calc(-1 * ((100vw - ${MAX_CONTENT_WIDTH}) / 2))`};
  }

  // maintain full bleed for desktop full width
  @media (max-width: ${MAX_CONTENT_SCREEN_WIDTH}) {
    margin-inline: ${({ isCompact }) => (isCompact ? 'unset' : `-${spacer48}`)};
  }
  @media (max-width: ${MD_GRID_MAX_WIDTH}) {
    margin-inline: ${({ isCompact }) => (isCompact ? 'unset' : `-${spacer40}`)};
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    margin-inline: -${spacer40};
  }
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    margin-inline: -${spacer16};
  }

  // show gradient edges when above max content width
  .gradient-edge {
    display: ${({ isCompact }) => (isCompact ? 'none' : 'block')};
    @media (max-width: ${RESPONSIVE_AFFORADANCE_VIDEO_SCREEN_MAX}) {
      display: none;
    }
  }
`;
//# sourceMappingURL=Carousel.js.map